// Arquivo gerado automaticamente no deploy
export const APP_VERSION = '9.3.6';
